// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"ebe3ecae","59":"dce566c4"}[chunkId] + ".chunk.js";
};